export const askNotificationPermission = async () => {
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};
